const MADCAP_ARTICLES = {
  HOW_TO_RESET_YOUR_PASSWORD:                        'HOW_TO_RESET_YOUR_PASSWORD',
  UNDERSTANDING_USER_ROLES_CAPABILITIES_IN_DETAIL:   'UNDERSTANDING_USER_ROLES_CAPABILITIES_IN_DETAIL',
  UNDERSTANDING_WEBSITE_SIGN_IN:                     'UNDERSTANDING_WEBSITE_SIGN_IN',
  HOW_TO_CONNECT_AND_RE_CONNECT_A_CHANNEL:           'HOW_TO_CONNECT_AND_RE_CONNECT_A_CHANNEL',
  UNDERSTANDING_INSIGHTS:                            'UNDERSTANDING_INSIGHTS',
  EXPERIENCE_LEVEL_INSIGHTS:                         'EXPERIENCE_LEVEL_INSIGHTS',
  MARIGOLD_GROW_PLATFORM_OVERVIEW:                   'MARIGOLD_GROW_PLATFORM_OVERVIEW',
  UNDERSTANDING_CONTENT_SERVICES_AN_OVERVIEW:        'UNDERSTANDING_CONTENT_SERVICES_AN_OVERVIEW',
  HOW_TO_MODERATE_CONTENT_IN_A_COLLECTION:           'HOW_TO_MODERATE_CONTENT_IN_A_COLLECTION',
  UNDERSTANDING_THE_EXPERIENCE_AREA:                 'UNDERSTANDING_THE_EXPERIENCE_AREA',
  UNDERSTANDING_DIFFERENT_WAYS_TO_EXPORT_ENTRY_DATA: 'UNDERSTANDING_DIFFERENT_WAYS_TO_EXPORT_ENTRY_DATA',
  HOW_TO_CREATE_A_COLLECTION_AND_ADD_A_FEED:         'HOW_TO_CREATE_A_COLLECTION_AND_ADD_A_FEED',
  INTRODUCING_INTEGRATIONS:                          'INTRODUCING_INTEGRATIONS',
  HOW_TO_ENABLE_EXPERIENCE_CUSTOM_SHARING_AND_ECHO:  'HOW_TO_ENABLE_EXPERIENCE_CUSTOM_SHARING_AND_ECHO',
  HOW_TO_ADD_CUSTOM_CSS_TO_A_THEME_OR_AN_EXPERIENCE: 'HOW_TO_ADD_CUSTOM_CSS_TO_A_THEME_OR_AN_EXPERIENCE',
  UNDERSTANDING_PAGES_MODULES:                       'UNDERSTANDING_PAGES_MODULES',
  UNDERSTANDING_ENTRY_FORMS:                         'UNDERSTANDING_ENTRY_FORMS',
  HOW_TO_SELECT_WINNERS_USING_WINNER_MANAGEMENT:     'HOW_TO_SELECT_WINNERS_USING_WINNER_MANAGEMENT',
  HOW_TO_CREATE_A_NEW_THEME:                         'HOW_TO_CREATE_A_NEW_THEME',
  HOW_TO_SET_UP_A_REVEAL_CAMPAIGN:                   'HOW_TO_SET_UP_A_REVEAL_CAMPAIGN',
  HOW_TO_SET_UP_A_GIVEAWAY_EXPERIENCE:               'HOW_TO_SET_UP_A_GIVEAWAY_EXPERIENCE',
  HOW_TO_SET_UP_A_PERSONALITY_QUIZ_CATEGORY_QUIZ_EXPERIENCE:
    'HOW_TO_SET_UP_A_PERSONALITY_QUIZ_CATEGORY_QUIZ_EXPERIENCE',
  UNDERSTANDING_THE_EXPERIENCE_LIBRARY:                     'UNDERSTANDING_THE_EXPERIENCE_LIBRARY',
  HOW_TO_SET_UP_A_CONTENT_CAMPAIGN_EXPERIENCE:              'HOW_TO_SET_UP_A_CONTENT_CAMPAIGN_EXPERIENCE',
  HOW_TO_SETUP_A_PHOTO_CONTEST_EXPERIENCE:                  'HOW_TO_SETUP_A_PHOTO_CONTEST_EXPERIENCE',
  HOW_TO_SET_UP_A_POLL_EXPERIENCE:                          'HOW_TO_SET_UP_A_POLL_EXPERIENCE',
  UNDERSTANDING_INSTAGRAM_FEEDS_HASHTAG_COMPETITIONS:       'UNDERSTANDING_INSTAGRAM_FEEDS_HASHTAG_COMPETITIONS',
  HOW_TO_SET_UP_A_COLLAGE:                                  'HOW_TO_SET_UP_A_COLLAGE',
  HOW_TO_SET_UP_NEXTGEN_MICRO_EXPERIENCE_WITH_DATA_CAPTURE: 'HOW_TO_SET_UP_NEXTGEN_MICRO_EXPERIENCE_WITH_DATA_CAPTURE',
  HOW_TO_SET_UP_A_COUPON_EXPERIENCE:                        'HOW_TO_SET_UP_A_COUPON_EXPERIENCE',
  UNDERSTANDING_IMAGE_COPY_REQUIREMENTS:                    'UNDERSTANDING_IMAGE_COPY_REQUIREMENTS',
  HOW_TO_CREATE_AN_ACCOUNT_FORM:                            'HOW_TO_CREATE_AN_ACCOUNT_FORM',
  HOW_TO_ADD_A_NEW_USER_SET_THEIR_USER_ROLE:                'HOW_TO_ADD_A_NEW_USER_SET_THEIR_USER_ROLE',
  INTRODUCING_ENHANCED_ANALYTICS:                           'INTRODUCING_ENHANCED_ANALYTICS',
  HOW_TO_MANAGE_DATA_REQUESTS:                              'HOW_TO_MANAGE_DATA_REQUESTS',
  FREQUENTLY_ASKED_QUESTIONS_FAQ_TWITTER_CHANGES:           'FREQUENTLY_ASKED_QUESTIONS_FAQ_TWITTER_CHANGES',
  DATA_RETENTION_POLICY:                                    'DATA_RETENTION_POLICY',
  INTRODUCING_CUSTOM_DOMAINS:                               'INTRODUCING_CUSTOM_DOMAINS',
  HOW_TO_SAVE_AS_A_TEMPLATE_CREATE_AN_EXPERIENCE_FROM_A_TEMPLATE:
    'HOW_TO_SAVE_AS_A_TEMPLATE_CREATE_AN_EXPERIENCE_FROM_A_TEMPLATE',
  UNDERSTANDING_EMAIL_NOTIFICATION_TOKENS:                'UNDERSTANDING_EMAIL_NOTIFICATION_TOKENS',
  SENDING_EMAILS_FAIR_USAGE_ADD_ONS:                      'SENDING_EMAILS_FAIR_USAGE_ADD_ONS',
  UNDERSTANDING_EXPERIENCE_EXPORTS:                       'UNDERSTANDING_EXPERIENCE_EXPORTS',
  PRIVACY_MANAGEMENT_API_FOR_NEXTGEN_EXPERIENCES:         'PRIVACY_MANAGEMENT_API_FOR_NEXTGEN_EXPERIENCES',
  FORM_YOUR_FORM_DOES_NOT_CONTAIN_A_REQUIRED_EMAIL_FIELD: 'FORM_YOUR_FORM_DOES_NOT_CONTAIN_A_REQUIRED_EMAIL_FIELD',
  INTRODUCING_REAL_TIME_POLLS:                            'INTRODUCING_REAL_TIME_POLLS',
  PRIVACY_MANAGEMENT_API_FOR_MACRO_EXPERIENCES:           'PRIVACY_MANAGEMENT_API_FOR_MACRO_EXPERIENCES',
  LATEST_RELEASE_NOTES:                                   'LATEST_RELEASE_NOTES',
  UNDERSTANDING_CONTEST_COMPETITION_DATES_PHASES:         'UNDERSTANDING_CONTEST_COMPETITION_DATES_PHASES',
  REWARDS:                                                'REWARDS',
  PUBLISHING_AN_EXPERIENCE:                               'PUBLISHING_AN_EXPERIENCE',
  TROUBLESHOOTING_MISSING_INSTAGRAM_BUSINESS_ACCOUNTS:    'TROUBLESHOOTING_MISSING_INSTAGRAM_BUSINESS_ACCOUNTS',
  HOW_TO_SET_UP_A_FORM_EXPERIENCE:                        'HOW_TO_SET_UP_A_FORM_EXPERIENCE',
  PUBLISHING_EXPERIENCE_PAGES_STILL_CONTAINS_LOREM_IPSUM_TEXT:
    'PUBLISHING_EXPERIENCE_PAGES_STILL_CONTAINS_LOREM_IPSUM_TEXT',
  INSTAGRAM_7_DAYS_ROLLING_30_HASHTAG_LIMITATION: 'INSTAGRAM_7_DAYS_ROLLING_30_HASHTAG_LIMITATION',
  LANDINGPAGE:                                    'LANDINGPAGE',
  WELCOME:                                        'WELCOME',
  HOW_TO_PUBLISH_EXPERIENCES_TO_CUSTOM_DOMAINS:   'HOW_TO_PUBLISH_EXPERIENCES_TO_CUSTOM_DOMAINS',
  GROWRELEASENOTESSECTION:                        'GROWRELEASENOTESSECTION',
  HOW_TO_CUSTOMIZE_A_WEB_POPUP_USING_HTML_CSS_AND_JAVASCRIPT:
    'HOW_TO_CUSTOMIZE_A_WEB_POPUP_USING_HTML_CSS_AND_JAVASCRIPT',
  HOW_TO_ADD_A_COOKIE_BANNER_TO_YOUR_EXPERIENCES: 'HOW_TO_ADD_A_COOKIE_BANNER_TO_YOUR_EXPERIENCES',
};

const MADCAP_URLS = {
  THEMES: 'grow/Content/Getting%20Started/Themes/Themes_category.htm?Highlight=themes',
};

const CATEGORIES = {
  COLLECTIONS:        'collections',
  CAMPAIGN:           'campaign',
  EXPERIENCE_LIBRARY: 'experiencelibrary',
  ASSET:              'asset',
  THEME:              'theme',
  FORM:               'form',
  ACCOUNT:            'account',
  USER:               'user',
};
window.MADCAP_ARTICLES = MADCAP_ARTICLES;
export { MADCAP_ARTICLES, CATEGORIES, MADCAP_URLS };
